import { ColumnTypeDefault, ColumnTypeHelp, ColumnTypeHelpMobile, ColumnTypeInsuranceLimits, ColumnTypeName, ColumnTypePrice,
  ColumnTypePriceIncludes, ColumnTypeSuriIndex, ColumnTypeSuriIndexMerged } from './index'

export default {
  columnTypeDefault: ColumnTypeDefault,
  columnTypeHelp: ColumnTypeHelp,
  columnTypeHelpMobile: ColumnTypeHelpMobile,
  columnTypeInsuranceLimits: ColumnTypeInsuranceLimits,
  columnTypeName: ColumnTypeName,
  columnTypePrice: ColumnTypePrice,
  columnTypePriceIncludes: ColumnTypePriceIncludes,
  columnTypeSuriIndex: ColumnTypeSuriIndex,
  columnTypeSuriIndexMerged: ColumnTypeSuriIndexMerged,
}
